<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <div class="header pb-3">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-4">
          <div class="col-lg-12">
            <h6 class="h2 d-inline-block mb-0">2D AI Assessment</h6>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form class="form" [formGroup]="formGroup" novalidate>

    <div class="card">
      <div class="card-header">
        <h5  class="mb-0">Details</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-4 row-flex-media">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="form-control-label" for="title"> Assessment Title </label>
                  <input class="form-control" formControlName="title" maxlength="75" type="text" />
                  <div class="invalid-message" *ngIf="formGroup?.controls['title'].errors && formGroup?.controls['title'].errors.required">
                    <div>Title is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-end">
              <div class="col-md-5">
                <label class="form-control-label" for="runnerWeight">Patient's Weight</label>
                <input class="form-control" formControlName="runnerWeight" placeholder="Weight (e.g., 154)" type="text" (input)="onDecimalInput($event)" inputmode="decimal" />
                <div class="invalid-message" *ngIf="formGroup?.controls['runnerWeight'].errors && formGroup?.controls['runnerWeight'].errors.required">
                  <div>Title is required</div>
                </div>
              </div>
              <div class="col-md-3">
                <select class="form-control" formControlName="weightUnit" id="weightUnit">
                  <option [ngValue]="1">Lb</option>
                  <option [ngValue]="2">Kg</option>
                </select>
              </div>
            </div>
            <div class="row align-items-end">
              <div class="col-md-5">
                <label class="form-control-label" for="runnerHeight">Patient's Height</label>
                <input class="form-control" formControlName="runnerHeight" placeholder="Height (e.g., 70.5)" type="text" (input)="onDecimalInput($event)" inputmode="decimal" />
                <div class="invalid-message" *ngIf="formGroup?.controls['runnerHeight'].errors && formGroup?.controls['runnerHeight'].errors.required">
                  <div>Title is required</div>
                </div>
              </div>
              <div class="col-md-3">
                <select class="form-control" formControlName="heightUnit" id="heightUnit">
                  <option [ngValue]="2">Inches</option>
                  <option [ngValue]="1">Cm</option>
                </select>
              </div>
            </div>
            <div class="row align-items-end">
              <div class="col-md-5">
                <label class="form-control-label" for="speed">Gait Speed</label>
                <input class="form-control" formControlName="speed" placeholder="Speed (e.g., 9.58)" type="text" (input)="onDecimalInput($event)" inputmode="decimal" />
              </div>
              <div class="col-md-3">
                <select class="form-control" formControlName="speedUnit" id="speedUnit">
                  <option [ngValue]="2">Mph</option>
                  <option [ngValue]="1">Kmh</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-8 row-flex-media">
            <div class="video-examples-bar">
              <button class="video-example-btn" (click)="showSideExampleVideo()">
                <i class="fas fa-video"></i> View Side Tutorial
              </button>
              <button class="video-example-btn" (click)="showBackExampleVideo()">
                <i class="fas fa-video"></i> View Back Tutorial
              </button>
            </div>
            <div class="main-container">
              <div class="guideline-title">2D Video Guidelines</div>
              <div class="guideline-container">
                <!-- Required -->
                <div class="guideline-box required">
                  <div class="section-title">Required</div>
                  <ul>
                    <li>Camera is steady and level with the ground</li>
                    <li>The treadmill is parallel to the ground with no tilt</li>
                    <li>Foot and Head are always visible</li>
                    <li>Minimal obstruction of hip/knee by the treadmill</li>
                    <li>60 frames per second, HD</li>
                    <li>No slow-motion effect</li>
                    <li>Runner at steady speed before recording</li>
                    <li>The Video is not shot against a bright light source</li>
                  </ul>
                </div>
                <!-- Recommended -->
                <div class="guideline-box recommended">
                  <div class="section-title">Recommended</div>
                  <ul>
                    <li>Camera is exactly perpendicular to the view (lateral or posterior)</li>
                    <li>Camera is at approximately knee height</li>
                    <li>Well lit from the side you are recording</li>
                    <li>Foot is visible at initial contact and toe-off</li>
                    <li>Tight Fitting Clothes</li>
                    <li>Clothes contrast with the background</li>
                    <li>Shirt tucked into pants
                    <li>No other people in the camera view</li>
                  </ul>
                </div>
                <!-- Preferred -->
                <div class="guideline-box preferred">
                  <div class="section-title">Preferred</div>
                  <ul>
                    <li>Between 5-10 seconds for each video</li>
                    <li>Video is in vertical format</li>
                    <li>Different colored shirt and pants</li>
                    <li>Multiple trials</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="row mt-1">
            <div class="col-12">
              <h5 class="mt-2">Gait Assessment Videos</h5>
              <div formArrayName="videos" class="formGroupContainer" *ngFor="let video of formGroup.get('videos').controls; let v = index">
                <div class="row formGroupName image-border sortable-show-hover" [formGroupName]="v">
                  <div class="form-group col-md-6">
                    <video-upload *ngIf="!video.get('id').value"
                                  [label]="v === 0 ? 'Video ' + (v + 1) + ' - Side View Left or Right 5 - 10 seconds' : 'Video ' + (v + 1) + ' - Back View 5 - 10 seconds'"
                                  formControlName="videoId">
                    </video-upload>
                    <div *ngIf="video.get('id').value" class="pt-2">
                      <embed-video-player [size]="'small'" [videoId]="video.get('videoId').value"></embed-video-player>
                    </div>
                  </div>
                  <div class="form-group col-md-6 row-flex-media">
                    <div class="row right">
                      <div class="col-12">
                        <label class="form-control-label" for="description"> Video {{ v + 1 }} Description </label>
                        <input class="form-control" formControlName="description" maxlength="100" type="text" />
                      </div>
                      <!--<div class="col-2 row-flex-media">
                        <div class="gradient-box form-control">
                          See Example
                        </div>
                      </div>-->
                     </div>
                    </div>
                </div>
              </div>
            </div>
            <div *ngIf="formGroup.get('videos')?.errors?.twoVideosRequired && (formGroup.get('videos')?.touched || formGroup.get('videos')?.dirty)">
              <div class="text-danger">Please upload both videos</div>
            </div>
          </div>
        </div>
      </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="form-control-label" for="notes"> Assessment Notes </label>
          <textarea class="form-control" formControlName="assessmentNotes" maxlength="750" type="text"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
      </div>
      <div class="col text-right">
        <button (click)="onSave(false)" [promiseBtn]="submitComplete" class="btn btn-primary">Analyze</button>
      </div>
    </div>
  </form>
</div>
